const React = require('react');
import { Filter } from './Filter';
const { useTranslation } = require('react-i18next');

export const NavigationBar = ({
  setEvent,
  event,
  choices,
  typesDictionary,
  setTypesList,
  filterMenuTypes,
}) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        width: '100%',
        justifyContent: 'center',
        display: 'flex',
        borderBottom: '1px solid var(--color-grey-91)',
        position: 'sticky',
        top: 0,
        backgroundColor: 'var(--color-grey-100)',
        borderTopRightRadius: '5px',
        borderTopLeftRadius: '5px',
        zIndex: '1000',
      }}
    >
      <div className='flex-grow-1' />
      <ul className='nav' role='tablist'>
        <li className='nav-item'>
          <a
            className={
              'nav-link font-weight-semi-bold text-size-13 ' +
              (event === choices[0]
                ? 'text-blue-primary underline '
                : 'text-grey71 ')
            }
            onClick={() => {
              setEvent(choices[0]);
            }}
            id={choices[0]}
            style={{ letterSpacing: '0.07em' }}
            data-toggle='tab'
            href='#'
            role='tab'
          >
            {t(choices[0]).toUpperCase()}
          </a>
        </li>
        <li className='nav-item'>
          <a
            className={
              'nav-link font-weight-semi-bold text-size-13 ' +
              (event === choices[1]
                ? 'text-blue-primary underline '
                : 'text-grey71 ')
            }
            onClick={() => {
              setEvent(choices[1]);
            }}
            id={choices[1]}
            style={{ letterSpacing: '0.07em' }}
            data-toggle='tab'
            href='#'
            role='tab'
          >
            {t(choices[1]).toUpperCase()}
          </a>
        </li>
      </ul>

      <div className='d-flex justify-content-end flex-grow-1'>
        <Filter
          typesList={filterMenuTypes}
          typesDictionary={typesDictionary}
          event={event}
          setTypesList={setTypesList}
        />
      </div>
    </div>
  );
};
